import React from 'react';
import {
  Dropdown,
} from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const listItems = (intl, value, list) => Object.values(list).map((transferType) => ({
  key: `request_transfer_type_dropdown_item_${transferType}`,
  text: intl.formatMessage({ id: `transfer.type.${transferType}` }),
  value: transferType,
  active: transferType === value,
}));

const RequestTransferTypeDropdown = ({
  transferType,
  transferTypes,
  disabled,
  onChange,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      className="aridhia-request-transfer-type-dropdown"
      options={listItems(intl, transferType, transferTypes)}
      disabled={disabled}
      placeholder={intl.formatMessage({ id: 'request.select.transfer.type' })}
      value={transferType}
      selection
      fluid
      onChange={(e, { value }) => onChange(value)}
    />
  );
};

export default RequestTransferTypeDropdown;
